<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title> Benutzer </mat-card-title>
    <app-continuous-action #loading></app-continuous-action>

    <form [formGroup]="form">
      <div class="search-container row">
        <mat-form-field>
          <mat-label>Suche</mat-label>
          <input id="input" matInput formControlName="text" autocomplete="off" (input)="paginator.firstPage()" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>Benutzergruppe</mat-label>
          <mat-select id="select1" formControlName="userType" [aria-label]="'Benutzergruppe'" (selectionChange)="updateFilters(); paginator.firstPage()">
            <mat-option value=""></mat-option>
            <mat-option *ngFor="let u of this.UserType | keyvalue" [value]="u.key">{{ u.value }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Berechtigungen</mat-label>
          <mat-select id="select2" formControlName="userPrivilege" (selectionChange)="paginator.firstPage()">
            <mat-option value=""></mat-option>
            <mat-option *ngFor="let u of this.UserPrivilege | keyvalue" [value]="u.key">{{ u.value }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </form>

    <mat-card-content>
      <table mat-table #table [dataSource]="users$">
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <ng-container matColumnDef="name" class="mnetUser">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td *matCellDef="let u" (click)="openUserModal(u)" class="mnetUser">
            <em class="fas fa-user-edit mnetUser"></em>
            {{ u.firstName }} {{ u.lastName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>E-Mail</th>
          <td *matCellDef="let u">
            <a class="email" [href]="'mailto:' + u.email">
              <em class="fas fa-envelope-open"></em>
              {{ u.email }}</a
            >
          </td>
        </ng-container>

        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef>Berechtigungen</th>
          <td *matCellDef="let u">
            <div *ngIf="u.userType == 'MA'">
              {{ UserPrivilege[u.userPrivilege] }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="usertype">
          <th mat-header-cell *matHeaderCellDef>Benutzergruppe</th>
          <td *matCellDef="let u">{{ u.userType }}</td>
        </ng-container>

        <ng-container matColumnDef="mnetId">
          <th mat-header-cell *matHeaderCellDef>MNET-ID</th>
          <td *matCellDef="let u">
            {{ u.mnetId }}
          </td>
        </ng-container>
      </table>
      <mat-paginator #paginator [pageSize]="25" [pageSizeOptions]="[25, 100, 1000]" [length]="total$ | async"></mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
<app-edit-user *ngIf="this.selectedUser" (closeEvent)="closeDialog()" [form]="this.selectedUser"></app-edit-user>
